module.exports = __webpack_public_path__ + "img/onb3.88d200d9.svg";